module.exports = __webpack_public_path__ + "img/bowen6.7911989c.png";